import React from 'react';
import {Button} from "../../Button";
import Modal from "../../Modal";

class AskDescription extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showTips: false,
        }
    }

    render() {
        return (
            <div id={"askDescription"}>
                <Modal toggle={this.state.showTips} handleClose={() => this.setState({showTips: false})}>
                    <div className={`description-tips-container ${this.state.showTips ? 'active' : ''}`}>
                        <div className={"card big wrap"}>
                            <ul>
                                <li>Que cherchez vous en vous inscrivant sur Voissa ?</li>
                                <li>Qu'aimez vous dans la vie ? (vos passions)</li>
                                <li>Quelles sont vos qualités, ce qu'apprécient vos amis chez vous ?</li>
                            </ul>
                            <ul>
                                <li>Quel type de photos et vidéos aimez vous regarder ?</li>
                                <li>Un conseil pour retenir votre attention ?</li>
                                <li>Une citation ou un passage de poème que vous aimez ?</li>
                            </ul>
                            <div className={"btn-group"}>
                                <Button size={"small"}
                                        btnStyle={"grey"}
                                        onClick={() => this.setState({showTips: false})}
                                        content={"Fermer"}/>
                            </div>
                        </div>
                    </div>
                </Modal>
                <div className={"description-tips-text"}>Du mal à trouver l’inspiration pour votre description? <span
                    className={"click-here"} onClick={() => this.setState({showTips: true})}>Cliquez ici</span></div>
                <textarea name={"description"} placeholder={"Ce que vous aimez, recherchez, voulez, ..."}
                          value={this.props.description}
                          onChange={(event) => this.props.handleData("description", event.target.value)}/>
                <span
                    className={`minimum-description ${this.props.description.length < 20 ? 'error' : ''}`}>(minimum {this.props.description.length <= 20 ? 20 - this.props.description.length : 0} caractères restant)</span>
            </div>
        )
    }
}


export default AskDescription;